import __request__ from "routing/request";
export function status(requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.auditlog/status", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function statusAll(requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.auditlog/status/all", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
